import React from 'react';
import Relay from 'react-relay';

class SportDashboard extends React.Component {

    constructor(props) {
        super(props);
    }

    calculateStats(sportunities) {
        let sports = [];

        sportunities.forEach(sportunity => {
            let sport = sportunity.node.sport.sport.name.EN ;
            sports.push(sport);
        });

        let counts = {};

        for(var i = 0; i< sports.length; i++) {
            var num = sports[i];
            counts[num] = counts[num] ? counts[num]+1 : 1;
        }
        
        let sortable = [];

        for (var count in counts) {
            let percentage = Math.round(counts[count] * 100 / sportunities.length);
            sortable.push([count, counts[count], percentage]);
        }

        sortable.sort((a,b) => {return b[1] - a[1]});

        return sortable;
    }

    render() {
        let sportunities = this.props.viewer.sportunities.edges ;

        let sports = this.calculateStats(sportunities);

        return (
            <div className="container" style={{marginTop:20}}>
                <table className="table table-hover table-condensed">
                    <thead>
                        <tr>
                            <th>Sport</th>
                            <th>Nb of sportunities</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            sports.map((sport,index) => {
                                return (<tr key={index}><td>{sport[0]}</td><td>{sport[1]}</td><td>{sport[2]}</td></tr>)
                            }
                        )}
                    </tbody>

                </table>
            </div>            
        )

    }
}



SportDashboard.propTypes = ({
  children: React.PropTypes.node,
});

export default Relay.createContainer(SportDashboard, {
  fragments: {
    viewer: () => Relay.QL`
    fragment on Viewer { 
        sportunities (last:1000) {
            edges {
                node {
                    sport {
                        sport {
                            name {
                                EN
                            }
                        }
                    }
                }
            }
        }
    }`,
  }
});



// WEBPACK FOOTER //
// ./src/pages/Dashboard/SportsDashboard.js